import { useEffect, useState } from "react";
import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const th = {
  padding: "6px 10px", fontSize: "12px", fontWeight: "bold", textAlign: "left",
  background: "#d4d0c8", borderBottom: "1px solid #808080", borderRight: "1px solid #e6e3da",
  whiteSpace: "nowrap",
};
const td = { padding: "6px 10px", fontSize: "13px", borderBottom: "1px solid #e8e8e8", whiteSpace: "nowrap" };
const numInput = { width: 90, textAlign: "right", fontSize: "13px" };

export default function GestionCategoriesQVerifModal({ onClose, showPopup }) {
  const [rows, setRows] = useState([]);
  const [dirty, setDirty] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = () => {
    setLoading(true);
    axios.get(`${API}/admin/categories-qverif`, { withCredentials: true })
      .then(r => { setRows(r.data || []); setDirty({}); })
      .catch(err => showPopup?.(err?.response?.data?.detail || "Erreur de chargement.", "error", "Questionnaire de vérification"))
      .finally(() => setLoading(false));
  };
  useEffect(load, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setField = (id, field, value) => {
    setRows(rs => rs.map(r => r.id === id ? { ...r, [field]: value } : r));
    setDirty(d => ({ ...d, [id]: true }));
  };

  const handleSave = async () => {
    const ids = Object.keys(dirty).map(Number);
    if (!ids.length) return;
    for (const r of rows.filter(r => dirty[r.id])) {
      if (r.intervalle_verif === "" || r.compteur === "" || Number(r.intervalle_verif) < 0 || Number(r.compteur) < 0) {
        showPopup?.(`Catégorie ${r.id} : l'intervalle et le compteur doivent être des nombres ≥ 0.`, "warning", "Questionnaire de vérification");
        return;
      }
    }
    setSaving(true);
    try {
      for (const r of rows.filter(r => dirty[r.id])) {
        await axios.put(`${API}/admin/categories-qverif/${r.id}`, {
          intervalle_verif: Number(r.intervalle_verif),
          compteur: Number(r.compteur),
          actif: !!r.actif,
        }, { withCredentials: true });
      }
      showPopup?.("Modifications enregistrées.", "info", "Questionnaire de vérification");
      load();
    } catch (err) {
      showPopup?.(err?.response?.data?.detail || "Erreur lors de l'enregistrement.", "error", "Questionnaire de vérification");
    } finally {
      setSaving(false);
    }
  };

  const nbDirty = Object.keys(dirty).length;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div
        className="etab-modal"
        onClick={e => e.stopPropagation()}
        style={{ maxWidth: 860, width: "94%", display: "flex", flexDirection: "column", overflow: "hidden" }}
        data-testid="gestion-catqverif-modal"
      >
        <div className="popup-header" style={{ background: "#0033A0", padding: "6px 12px", flexShrink: 0 }}>
          <span className="popup-title">GESTION DU QUESTIONNAIRE DE VÉRIFICATION</span>
          <button className="win-modal-close" onClick={onClose} data-testid="gestion-catqverif-btn-x">×</button>
        </div>

        <div style={{ padding: "12px 14px", fontSize: "13px", background: "#ece9d8", borderBottom: "1px solid #a0a0a0" }}>
          Le client est sélectionné lorsque <b>(Compteur + 1) modulo Intervalle = 0</b> (catégories 2 à 7).
          Un intervalle de <b>1</b> sélectionne chaque demande; un intervalle de <b>0</b> ne sélectionne jamais.
        </div>

        <div style={{ overflow: "auto", maxHeight: "60vh" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }} data-testid="gestion-catqverif-table">
            <thead>
              <tr>
                <th style={th}>ID</th>
                <th style={th}>Catégorie</th>
                <th style={{ ...th, textAlign: "right" }}>Intervalle</th>
                <th style={{ ...th, textAlign: "right" }}>Compteur</th>
                <th style={{ ...th, textAlign: "center" }}>Actif</th>
                <th style={{ ...th, textAlign: "right" }}>Prochaine sélection</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td style={td} colSpan={6}>Chargement...</td></tr>
              ) : rows.map(r => {
                const iv = Number(r.intervalle_verif) || 0;
                const cpt = Number(r.compteur) || 0;
                const prochaine = (r.id > 1 && iv > 0)
                  ? `dans ${iv - (cpt % iv)} demande(s)`
                  : "jamais";
                return (
                  <tr key={r.id} data-testid={`catqverif-row-${r.id}`}
                      style={{ background: dirty[r.id] ? "#fff7dd" : "transparent" }}>
                    <td style={td}>{r.id}</td>
                    <td style={{ ...td, minWidth: 260 }}>{r.description}</td>
                    <td style={{ ...td, textAlign: "right" }}>
                      <input className="win-input" type="number" min="0" style={numInput}
                             data-testid={`catqverif-intervalle-${r.id}`}
                             value={r.intervalle_verif}
                             onChange={e => setField(r.id, "intervalle_verif", e.target.value)} />
                    </td>
                    <td style={{ ...td, textAlign: "right" }}>
                      <input className="win-input" type="number" min="0" style={numInput}
                             data-testid={`catqverif-compteur-${r.id}`}
                             value={r.compteur}
                             onChange={e => setField(r.id, "compteur", e.target.value)} />
                    </td>
                    <td style={{ ...td, textAlign: "center" }}>
                      <input type="checkbox" style={{ width: 16, height: 16 }}
                             data-testid={`catqverif-actif-${r.id}`}
                             checked={!!r.actif}
                             onChange={e => setField(r.id, "actif", e.target.checked)} />
                    </td>
                    <td style={{ ...td, textAlign: "right", color: "#555" }}
                        data-testid={`catqverif-prochaine-${r.id}`}>
                      {prochaine}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, padding: "12px 14px",
                      background: "#ece9d8", borderTop: "1px solid #a0a0a0" }}>
          <button className="win-btn" onClick={onClose} data-testid="gestion-catqverif-btn-fermer">Fermer</button>
          <button className="win-btn" onClick={handleSave} disabled={saving || !nbDirty}
                  data-testid="gestion-catqverif-btn-enregistrer"
                  style={{ fontWeight: "bold" }}>
            {saving ? "Enregistrement..." : `Enregistrer${nbDirty ? ` (${nbDirty})` : ""}`}
          </button>
        </div>
      </div>
    </div>
  );
}
